module Omni {
    /*  Add all global module registrations here for dependency injection,
        include external libraries first (such as ngAnimate) and internal libraries second (such as omni.booker)
    */
    let app = angular.module("omni", [
        "ngResource",
        "ngSanitize",
        "ngAnimate",
        "ngTouch",
        "angular-cache",
        "ngAria",
        "duScroll",
        "ui.bootstrap",
        "ui.router",
        "omni.core",
        "omni.booker",
        "omni.resortmap"
    ]);
}
